import { Component, inject } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CaseService } from '../../../services/case.service';
import { AlphaSharedModule, PrimeNGModules } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-send-signal-modal',
    standalone: true,
    imports: [AlphaSharedModule, ...PrimeNGModules],
    templateUrl: './send-signal-modal.html',
})
export class SendSignalModalComponent {
    private config = inject(DynamicDialogConfig);
    private caseService = inject(CaseService);
    ref = inject(DynamicDialogRef);
    private message = inject(MessageService);

    caseInstances: any;
    sendSignalForm: Array<{ cid: string; piid: string; signalName: string; variables: FormControl<string> }> = [];
    users!: Record<'userName', any>[];

    ngOnInit() {
        this.caseInstances = this.config.data['caseInstances'];
        this.sendSignalForm = this.caseInstances?.map((inst: any) => {
            return {
                cid: inst.caseInstance.cid,
                piid: inst.signalInstance.piid,
                signalName: inst.signalInstance.signalName,
                variables: new FormControl('{}', [Validators.required, this.jsonStringValidator]),
            };
        });
    }

    delegateCases() {
        const formValue = this.sendSignalForm.map((row: any) => {
            return {
                cid: row.cid,
                piid: row.piid,
                signalName: row.signalName,
                variables: JSON.parse(row.variables.value),
            };
        });

        this.caseService.sendSignal(formValue).subscribe({
            next: (_data) => {
                this.ref.close(_data);
            },
            error: (_err) => {
                this.message.add({ severity: 'error', summary: 'Failed!', detail: 'Send signal Failed' });
            },
        });
    }

    isInvalid() {
        return this.sendSignalForm.some((item: any) => !item.variables.valid);
    }

    jsonStringValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        try {
            const variablesJson = JSON.parse(value);
            if (Array.isArray(variablesJson)) throw new Error();
            return null;
        } catch (err) {
            return { error: true };
        }
    }
}
